const Empty = ({ message }: { message: string }) => {
  return <h2 className='text-gray-400 text-center'>{message}</h2>;
};

export default Empty;
